import { useEffect, useRef } from 'react';

const useResize = (callback: () => void): void => {
  const callbackRef = useRef(callback);

  // Keep callback ref up to date
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const handleResize = () => callbackRef.current();

    handleResize(); // Call on mount
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // No dependencies - only runs once
};

export default useResize;
